<template>
	<div @click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editFireProtection.id ? $t('add_fire_protection.edit') : $t('add_fire_protection.new') }} {{ $t('add_fire_protection.title') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="columns is-mobile" style="margin-bottom: 12px;">
						<div class="field">
							<label class="label">{{ $t('add_fire_protection.name') }}</label>
							<div class="control">
								<input
									type="text"
									v-model="fireProtection.name"
									class="input"
									:placeholder="$t('add_fire_protection.name_placeholder')"
								/>
							</div>
						</div>
					</div>
					<div class="columns is-mobile" style="margin-bottom: 12px;">
						<div class="field has-multiselect column is-half">
							<label class="label">{{ $t('add_fire_protection.group') }}</label>
							<div class="control">
								<v-select
									class="panel-select narrow"
									v-model="chosenInventoryGroupId"
									:options="fireProtectionGroupOptions"
									track-by="value"
									:reduce="opt => Number(opt.value)" 
									label="text"
									:placeholder="$t('add_fire_protection.select_type')"
									:allowEmpty="false"
									:internalSearch="true"
									:showLabels="false"
									>
									<template slot="no-options">
										{{ $t('add_fire_protection.no_results') }}
									</template>

									<template slot="open-indicator" slot-scope="{ attributes }">
										<span class="caret" v-bind="attributes">
										<i class="fas fa-caret-down caret-inner"></i>
										</span>
									</template>
								</v-select>
							</div>
						</div>
				
							<div class="field has-multiselect column is-half">
							<label class="label">{{ $t('add_fire_protection.type') }}</label>
							<div class="control">
								<div class="select is-fullwidth">
								<select v-model="selectedCategoryId">
									<option disabled value="">
									{{ $t('flaw_view.flaw_category_placeholder') }}
									</option>
									<option
									v-for="category in flawCategories"
									:key="category.id"
									:value="category.id"
									>
									{{ category.translationKeyTranslated }}
									</option>
								</select>
								</div>
							</div>
							</div>

					</div>
					<div class="field">
						<label class="label">{{ $t('add_fire_protection.description') }}</label>
						<div class="control">
							<textarea
								v-model="fireProtection.description"
								class="textarea"
								rows="2"
								:placeholder="$t('add_fire_protection.description_placeholder')"
							/>
						</div>
					</div>
					<div class="field">
						<label class="label">{{ $t('add_fire_protection.recommendation') }}</label>
						<div class="control">
							<textarea
								v-model="fireProtection.recommendation"
								class="textarea"
								rows="2"
									:placeholder="$t('add_fire_protection.recommendation_placeholder')"
							/>
						</div>
					</div>

					<div class="field ">
						<label class="label">{{ $t('add_fire_protection.instruction') }}</label>
						<div class="control">
							<textarea
								v-model="fireProtection.instruction"
								class="textarea"
								rows="2"
								:placeholder="$t('add_fire_protection.instruction_placeholder')"
							/>
						</div>
					</div>
					<div class="field" v-if="$isAllowedTo('global_set_object_as_global')">
						<label class="label">{{ $t('add_fire_protection.global') }}</label>
						<SwitchButton v-model="globalVisibility" />
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>{{ $t('add_fire_protection.save') }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import iconMixin from '@/mixins/iconMixin.js';
import FlawService from '@/services/flaw';


import SwitchButton from '@/components/switchButton.vue';

export default {
  components: { SwitchButton },
  mixins: [iconMixin],
  props: { editFireProtection: Object, option:Object },
  data() {
    return {
      fireProtection: {
        name: '',
        description: '',
        recommendation: '',
        instruction: '',
		 inventoryType: ''
      },
      isLoading: false,
      saveingError: false,
      companyOptions: [],
      chosenInventoryGroupId: -1, 
      globalVisibility: false,
	  flawCategories: [],
	  selectedCategoryId: '',
	  selectedFlawTypeId: '',
    };
  },
  computed: {
    disableSave() {
      return !this.fireProtection.name;
    },
    ...mapGetters('companyStore', ['companies']),
    ...mapGetters('user', ['getActiveCompany', 'getActiveCustomer']),

    fireProtectionGroupIds() {
      return [0, 1, 2, 3, 4, 5];
    },
	filteredFlawTypes() {
		if (!Array.isArray(this.flawCategories)) return [];
		const category = this.flawCategories.find(c => c.id === this.selectedCategoryId);
		return category?.relatedFlawTypes || [];
	},

	fireProtectionGroupOptions() {
		return [
			{ value: -1, text: this.$t('add_fire_protection.not_selected') },
			...[0,1,2,3,4,5].map(id => ({ value: id, text: this.$t(`fire_protection_group.${id}`) }))
		];
	}
  },
  watch: {
	editFireProtection: {
	deep: true,
	immediate: false,
	handler(newVal) {
		if (!newVal) return;
			if (this.flawCategories?.length) {
				this.initFromEdit(newVal);
			} else {
				this.loadFlawData().then(() => this.initFromEdit(newVal));
			}
		}
  },
 	 selectedCategoryId() { this.selectedFlawTypeId = ''; },
		chosenInventoryGroupId(newVal) {
			const v = Number.isFinite(newVal) && newVal >= 0 ? newVal : null;
			this.fireProtection.fireProtectionType = v;
		}
  },
  methods: {
    ...mapActions('companyStore', ['getCompanies']),

	normalizeGroupId(val) {
		const n = Number(val);
		return Number.isFinite(n) && this.fireProtectionGroupIds.includes(n) ? n : -1;
	},
	 initFromEdit(fp) {
		this.fireProtection = {
		name: '',
		description: '',
		recommendation: '',
		instruction: '',
		inventoryType: '',
		...fp
		};

		const normalized = this.normalizeGroupId(fp?.fireProtectionType);
		this.chosenInventoryGroupId = normalized;
		this.fireProtection.fireProtectionType = normalized >= 0 ? normalized : 5;

		this.globalVisibility = this.fireProtection.companyId === null;

		const catId  = fp?.flawCategoryId ?? null;
		const typeId = fp?.flawTypeId ?? null;

		if (catId && this.flawCategories.some(c => c.id === catId)) {
		this.selectedCategoryId = catId;
		const types = (this.flawCategories.find(c => c.id === catId)?.relatedFlawTypes) || [];
		if (typeId && types.some(t => t.id === typeId)) this.selectedFlawTypeId = typeId;
		}
	},
	getSelectedCategory() {
		const id = this.selectedCategoryId;
		return this.flawCategories.find(c => String(c.id) === String(id)) || null;
	},
	async loadFlawData() {
		try {
		const language = this.$i18n?.locale || 'en';
		const response = await FlawService.GetFlawCategoriesWithFlawTypes(language);

		if (Array.isArray(response)) {
			this.flawCategories = response;

			if (!this.editFireProtection && this.flawCategories.length > 0) {
			this.selectedCategoryId = this.flawCategories[0].id;
			}
		} else {
			console.error('Unexpected flaw data format:', response);
			this.flawCategories = [];
		}
		} catch (e) {
		console.error('Failed to load flaw categories', e);
		this.flawCategories = [];
		}
	},
	save() {
		if (this.isLoading) return;

		const grpRaw = typeof this.chosenInventoryGroupId === 'object'
			? Number(this.chosenInventoryGroupId?.value)
			: Number(this.chosenInventoryGroupId);
		const fireProtectionType =
			Number.isFinite(grpRaw) && grpRaw >= 0 ? grpRaw : null; // ← null, not -1

		const selCat = this.getSelectedCategory();
		const inventoryKey = selCat?.translationKey || 'other';

		const flawCategoryId = this.selectedCategoryId || null;

		const payload = {
			...this.fireProtection,
			inventoryType: inventoryKey,     
			fireProtectionType: fireProtectionType ?? 5,               
			flawCategoryId,
			companyId: this.globalVisibility
			? null
			: (this.fireProtection.companyId ?? this.getActiveCompany?.id ?? null),
			customerId: this.globalVisibility
			? null
			: (this.fireProtection.customerId ?? this.getActiveCustomer?.id ?? null),
		};

		this.$emit('save', payload);
		this.isLoading = true;
	},


    cancel() {
      this.$emit('cancel');
    },
  },
	created() {
		if (this.editFireProtection) {
			Object.assign(this.fireProtection, this.editFireProtection);

			const raw = Number(this.editFireProtection.fireProtectionType);
			const normalized = Number.isFinite(raw) && this.fireProtectionGroupIds.includes(raw) ? raw : -1;

			this.chosenInventoryGroupId = normalized;
			this.fireProtection.fireProtectionType = normalized >= 0 ? normalized : 5;

			this.globalVisibility = this.fireProtection.companyId === null;
		} else {
			this.chosenInventoryGroupId = -1;
			this.fireProtection.fireProtectionType = 5; 
			this.globalVisibility = false;
		}

		this.loadFlawData().then(() => {
			if (this.editFireProtection) {
			this.initFromEdit(this.editFireProtection);
			} else {
			this.chosenInventoryGroupId = -1;
			this.fireProtection.fireProtectionType = 5;
			this.globalVisibility = false;
			if (!this.selectedCategoryId && this.flawCategories.length) {
				this.selectedCategoryId = this.flawCategories[0].id;
			}
			}
		});
	},
};
</script>

<style lang="scss" scoped>
.switch {
	margin-top: 0;
}
</style>
